import { Route, Routes } from 'react-router-dom';
import Completed from '../Components/Completed';
import { InvestigationGate } from '@components/InvestigationGate';

const AppRoutes = () => {
	return (
		<Routes>
			{/*
			 * RND-4193 — HRR PQ Phase 1.
			 * Per PM override of the v0.5 design doc (§6): URL stays `/?sc=XXXX` for
			 * ALL cases — no `/hrr` route is exposed. `<InvestigationGate />` reads
			 * `branchinvestigationdetails` and dispatches by `playbookVersion`:
			 *   - `'2.0'` → HRR v2 flow (`V2InvestigationPage`)
			 *   - else    → legacy v1 flow (`InvestigationUI`)
			 */}
			<Route path="/" element={<InvestigationGate />} />
			<Route path={'/InvestigationEnded'} element={<Completed />} />
		</Routes>
	);
};

export default AppRoutes;
